import algoliasearch from 'algoliasearch';
import algoliasearchHelper from 'algoliasearch-helper';

class Search {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  initialize() {
    this.visible = false;
    this.loading = false;
    this.activeClass = 'search-body--visible';
    this.activeResultClass = null;
    this.searchClient = algoliasearch(
      'LE0ZY5JG84',
      'a74bf93dab24d4bc10fb8c5a3665afc1'
    );
    this.search = algoliasearchHelper(
      this.searchClient,
      'contentful',
      {facets: ['type']}
    );

    this.bindUI();
    this.bindEvents();
  }

  unmount() {
    this.element.removeEventListener('click', () => this.toggleSearchModal());
    this.ui.$searchClose.removeEventListener('click', () => this.toggleSearchModal());
    this.ui.$searchBodyInput.removeEventListener('keyup', this.debounceFn(this.inputSearch));
    this.ui = {};
  }

  bindUI() {
    this.ui = {};
    this.ui.$searchType = this.element.getAttribute('data-type');
    this.ui.$searchBody = document.querySelector('[data-element="search"]');
    this.ui.$searchBodyInput = this.ui.$searchBody.querySelector('[data-ref="search-input"]'); // .js-search
    this.ui.$searchBodyResult = this.ui.$searchBody.querySelector('[data-ref="search-body-result"]'); // js-search-body__result
    this.ui.$searchClose = this.ui.$searchBody.querySelector('[data-element="search-close"]');
    this.ui.$loader = this.ui.$searchBody.querySelector('[data-element="search-page__loading"]');
  }

  bindEvents() {
    this.ui.$searchBody.style.display = 'none';

    this.element.addEventListener('click', () => this.toggleSearchModal());
    this.ui.$searchClose.addEventListener('click', () => this.toggleSearchModal());
    this.ui.$searchBodyInput.addEventListener('keyup', this.debounceFn(this.inputSearch));

    this.search.on('result', (event) => {
      this.loading = false;
      this.ui.$loader.style.display = 'none';
      this.addSearchResultClass();
      this.renderResults(event.results);
    });

    this.search.on('error', (e) => console.log(e, this.ui.$searchBodyInput.value));
  }

  debounceFn(fn, timeout = 500) {
    let setTimeoutFn;

    if (typeof fn != 'function') {
      throw new TypeError(`Expected a function but got '${typeof fn}' instead`);
    }

    return (...args) => {
      clearTimeout(setTimeoutFn);
      setTimeoutFn = setTimeout(() => fn.apply(this, args), timeout);
    };
  }

  addSearchResultClass() {
    if (this.activeResultClass) {
      this.ui.$searchBodyResult.classList.remove(this.activeResultClass);
    }

    if (this.ui.$searchType == 'post') {
      this.activeResultClass = 'search-body__result-post';
      this.ui.$searchBodyResult.classList.add(this.activeResultClass);
    }
  }

  toggleSearchModal() {
    if (this.visible) {
      this.ui.$searchBodyInput.value = '';
      this.ui.$searchBody.classList.remove(this.activeClass);
      setTimeout(() => {
        this.ui.$searchBody.style.display = 'none';
      }, 300);
      this.visible = false;
      document.body.style.overflow = 'initial';
    } else {
      this.ui.$searchBody.style.display = 'block';
      setTimeout(() => {
        this.ui.$searchBody.classList.add(this.activeClass);
      }, 300);
      this.ui.$searchBodyInput.focus();
      this.visible = true;
      document.body.style.overflow = 'hidden';
    }
  }

  inputSearch() {
    this.loading = true;
    this.ui.$loader.style.display = 'flex';
    this.setFacet('type', this.ui.$searchType);
    this.search.setQuery(this.ui.$searchBodyInput.value).search();
  }

  setFacet(key, name) {
    this.search.clearRefinements();
    this.search.addFacetRefinement(key, name);
  }

  renderPostResult(hit) {
    return `
      <a href="/${hit.url}" class="search-result__content btn--clean">
          <div class="search-result__content-header">
            <h2 class="type-body u-mb--space-fixed-3">${hit.title}</h2>
            <p class="type-caption f-serif date">${hit.date}</p>
          </div>
          <svg width="1em" height="1em" viewBox="0 0 19 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.1975 23.2057L13.0123 24L19 18.2316L13.1566 12.5317L12.3464 13.3221L16.8396 17.7042H1.08183V0H0V18.823H16.6913L12.1975 23.2057Z" fill="black"/>
          </svg>
      </a>
    `;
  }

  renderResults(results) {
    if (results.page === 0) this.ui.$searchBodyResult.innerHTML = '';
    this.ui.$searchBodyResult.innerHTML += results.hits.map(this.renderPostResult).join('');
  }
}

export default Search;
